var UnitSystem;
(function (UnitSystem) {
    UnitSystem["METRIC"] = "metric";
    UnitSystem["IMPERIAL_US"] = "imperial_us";
    UnitSystem["IMPERIAL_CA"] = "imperial_ca";
})(UnitSystem || (UnitSystem = {}));
export default UnitSystem;
//# sourceMappingURL=UnitSystem.js.map